import { FormControl, FormHelperText, FormLabel, Box, Stack, } from '@chakra-ui/react';
import React from 'react';
import FormFieldErrors from '../FormFieldErrors/FormFieldErrors';
import CustomSelect from '../CustomSelect/CustomSelect';
import { RenderIf } from '../RenderIf/RenderIf';
const StandardFormSelect = ({ label, error, helpText, isDisabled, testId, useRow = false, ...rest }) => {
    const stackProps = {
        direction: useRow ? 'row' : 'column',
        alignItems: useRow ? 'center' : 'flex-start',
    };
    return (React.createElement(FormControl, { isInvalid: !!error, isDisabled: isDisabled },
        React.createElement(Stack, { ...stackProps, spacing: 0, alignSelf: "stretch" },
            React.createElement(FormLabel, { w: "50%", "data-testid": "standard_form_select__label" }, label),
            React.createElement(Box, { w: "100%" },
                React.createElement(CustomSelect, { isDisabled: isDisabled, testId: testId, isInvalid: !!error, maxW: useRow ? '280px' : undefined, ...rest }),
                React.createElement(RenderIf, { condition: !!helpText },
                    React.createElement(FormHelperText, null, helpText)),
                React.createElement(FormFieldErrors, { errors: error })))));
};
export default StandardFormSelect;
